import {
  GET_NET_SHIP_STYLE_WISE_REQUEST,
  GET_NET_SHIP_STYLE_WISE_SUCCESS,
  GET_NET_SHIP_STYLE_WISE_ERROR,
} from "./types.js";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const getNetShipStyleWise = (token, data, report) => (dispatch) => {
  dispatch({ type: GET_NET_SHIP_STYLE_WISE_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/netShippedCustomerWise`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: {
      from_date: moment(data.from_date).format("MM-DD-YYYY"),
      to_date: moment(data.to_date).format("MM-DD-YYYY"),
      factor_id: data.paymentClass === "All" ? null : data.paymentClass,
      gender_id: data.gender_id === "All" ? null : data.gender_id,
      customer_type_id: data.customer_type === "All" ? null : data.customer_type,
      region_id: data.region_id === "All" ? null : data.region_id,
      sales_person_id: data.salesperson_id === "All" ? null : data.salesperson_id,
      priority_id: data.priority_id === "All" ? null : data.priority_id,
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_NET_SHIP_STYLE_WISE_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_NET_SHIP_STYLE_WISE_ERROR,
        payload: [],
      });
    });
};

